import React, { PureComponent } from 'react'
import defaultImg from '../../assets/images/pic-error.png'
import ImgPreview from "./ImgPreview";
import styles from './imageList.module.less'
import classname from 'classnames'

export default class ImageList extends React.Component {
    state = {
        src: null,
        imageInfoList: [],
        bigImageVisible: false,
    }
    componentDidMount() {
        this.setState({ imageInfoList: this.props.imageInfoList })
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevProps.imageInfoList) !== JSON.stringify(this.props.imageInfoList)) {
            this.setState({ imageInfoList: this.props.imageInfoList });
        }
    }

    handleError = () => {
        const { defaultImg } = this.props
        this.setState({ src: defaultImg })
    }

    onImgClick = (index) => {
        const { imageInfoList } = this.state;
        if (imageInfoList && imageInfoList.length > 0) {
            if (index >= 0 && index < imageInfoList.length) {
                this.setState({
                    src: imageInfoList[index].src,
                    bigImageVisible: true,
                })
            }
        }
    }

    handleClosePreview = () => {
        this.setState({ bigImageVisible: false })
    }
    onSwitch = (isLeft) => {
        const { imageInfoList, src } = this.state;
        if (imageInfoList && imageInfoList.length > 0) {
            let index = imageInfoList.findIndex(f1 => { return f1.src == src })
            isLeft ? index-- : index++;
            if (index < 0)
                index = 0;
            if (index >= imageInfoList.length)
                index = imageInfoList.length;
            if (index >= 0 && index < imageInfoList.length) {
                this.setState({
                    src: imageInfoList[index].src,
                    bigImageVisible: true,
                })
            }
        }
    }

    render() {
        const { src, bigImageVisible, imageInfoList } = this.state
        const { className, style, showImage } = this.props;
        const { onImgClick, onLeft, onRight } = this;
        return (
            <div className={classname(styles.main, className)}
                onClick={e => e.stopPropagation()}
                style={{ ...(style || {}), }}>

                {showImage ? showImage(imageInfoList, onImgClick) : ""}
                <ImgPreview
                    visible={bigImageVisible}  // 是否可见
                    onClose={this.handleClosePreview} // 关闭事件
                    src={src} // 图片url
                    onLeft={() => this.onSwitch(true)}
                    onRight={() => this.onSwitch(false)}
                    isAlwaysCenterZoom={false} // 是否总是中心缩放，默认false，若为true，每次缩放图片都先将图片重置回屏幕中间
                    isAlwaysShowRatioTips={false} // 是否总提示缩放倍数信息，默认false，只在点击按钮时提示，若为true，每次缩放图片都会提示
                /></div>
        )
    }

}